import { render, staticRenderFns } from "./PlatformTechniciansManagement.vue?vue&type=template&id=5cb975dc"
import script from "./PlatformTechniciansManagement.vue?vue&type=script&lang=js"
export * from "./PlatformTechniciansManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports